import axios from "../api/axios";
import {SLIDES_URL} from "../utils/constants";
import {SlideType} from "../models/SlydeType";

export async function slidesService(): Promise<SlideType[]> {
    const response = await axios.get(SLIDES_URL);
    return response.data;
}
